<!-- Ported from the Polaris kit: src/components/ui/input-group/InputGroupButton.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';
import { Button } from '../button';
import { inputGroupButtonVariants } from '.';

const props = defineProps({
  variant: { type: null, required: false, default: 'ghost' },
  size: { type: null, required: false, default: 'xs' },
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <Button
    :data-size="props.size"
    :variant="props.variant"
    :class="cn(inputGroupButtonVariants({ size: props.size }), props.class)"
  >
    <slot />
  </Button>
</template>
